export enum HISTORY_TYPE {
  TRANSFER_TO_DOCTOR = "TRANSFER_TO_DOCTOR",
  TRANSFER_TO_CALCULATOR = "TRANSFER_TO_CALCULATOR",
  CREATE = "CREATE",
  UPDATE = "UPDATE"
}